import { api } from "api/api";

export interface Request {
    code: string;
}
interface ResponseData {
    link: string;
}
interface Response {
    returnCode: number;
    data: ResponseData
}

export async function getRecommendationPublicLink({ code }: Request): Promise<Response> {
    const url = `api/mobile/appointment/recommendation/link/${code}`;
    const response = await api.get(url);
    return response.data;
}
